"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const formatURL = ({ videoConfig }) => {
    if (videoConfig.src === 'youtube') {
        return `https://www.youtube.com/embed/${videoConfig.videoId}`;
    }
    if (videoConfig.src === 'vimeo') {
        return `https://myagi.github.io/react-native-vimeo/v0.3.0.html?vid=${videoConfig.videoId}`;
    }
    return '';
};
const VideoViewRender = ({ control, style, }) => {
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const urlVideo = (0, react_1.useMemo)(() => {
        if (control.videoConfig && control.videoConfig.url) {
            return formatURL({ videoConfig: control.videoConfig });
        }
        return '';
    }, [control.videoConfig]);
    const videoStyle = (0, react_1.useMemo)(() => ({ flex: 1, backgroundColor: 'transparent' }), []);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        react_1.default.createElement(Render.View, { style: style },
            react_1.default.createElement(Render.VideoView, { videoConfig: control.videoConfig, style: videoStyle, javaScriptEnabled: true, source: urlVideo }))));
};
exports.default = VideoViewRender;
